/**
 * Përkthimet Shqip / English – krejt tekstit e aplikacionit
 */
export const translations = {
  sq: {
    // Layout & Nav (ekzistojnë)
    logout: 'Dil',
    more: 'Më shumë',
    home: 'Paneli',
    devices: 'Pajisjet',
    checkin: 'Check-in',
    alarms: 'Alarmet',
    reports: 'Raportet',
    kosova: 'Kosova',
    analysis: 'Analiza',
    analizat: 'Analizat',
    planning: 'Planifikimi',
    control: 'Kontroll',
    companies: 'Kompanitë',
    users: 'Përdoruesit',
    me: 'Unë',

    // Me / Profile
    report: 'Raportet',
    faults: 'Alarmet',
    links: 'Lidhje',
    about: 'Rreth',
    systemSettings: 'Cilësimet e sistemit',
    changePassword: 'Ndrysho fjalëkalimin',
    notification: 'Njoftimet',
    konfigurimi: 'Konfigurimi',
    statusOk: 'OK – duke punuar',
    statusStopped: 'Ndalur',
    statusActivating: 'Duke u nisur (activating)…',
    statusFailed: 'Dështoi (failed)',
    serverStopped: 'Serveri u ndal',
    noPermission: 'Nuk keni leje',
    noServers: 'Nuk u gjetën servera.',
    back: 'Mbrapsht',
    ...Object.fromEntries(Array.from({ length: 13 }, (_, i) => [`server${i + 1}`, `Server ${i + 1}`])),
    contactUs: 'Na kontaktoni',
    version: 'Versioni',

    // Login
    loginTitle: 'Kyçu',
    loginSubtitle: 'Shkruaj kredencialet për të vazhduar',
    username: 'Përdoruesi',
    passwordLabel: 'Fjalëkalimi',
    rememberCreds: 'Ruaj kredencialet',
    loginBtn: 'Kyçu',
    loggingIn: 'Duke u kyçur...',
    errorNetwork: 'Lidhja me serverin dështoi.',
    errorLogin: 'Gabim gjatë kyçjes. Provoni përsëri.',
    toggleThemeLabel: 'Ndrysho light/dark',

    // Common
    loading: 'Duke ngarkuar...',
    cancel: 'Anulo',
    save: 'Ruaj',
    close: 'Mbyll',
    delete: 'Fshi',
    edit: 'Ndrysho',
    add: 'Shto',
    apply: 'Apliko',
    search: 'Kerko',
    back: 'Kthehu',
    confirm: 'A je i sigurt?',
    errorGeneric: 'Gabim',
    password: 'Fjalëkalim',
    confirmCheck: 'Konfirmoj',
    execute: 'Ekzekuto',
    sending: 'Duke dërguar...',
    noCompanies: 'Nuk ka kompani',
    selectCompany: 'Zgjidh kompaninë',
    selectCompanyFirst: 'Zgjidhni një kompani.',
    company: 'Kompani',
    dataLogger: 'Regjistrues i Të Dhënave',
    dataLoggers: 'Regjistruesit e Të Dhënave',
    inverter: 'Inverter',
    inverters: 'Inverterët',
    energyMeter: 'Njehsor Energjie',
    energyMeters: 'Njehsorët e Energjisë',
    status: 'Statusi',
    type: 'Lloji',
    actions: 'Veprime',
    online: 'Online',
    offline: 'Offline',
    partial: 'Pjesërisht',
    normal: 'Normal',
    active: 'Aktive',
    inactive: 'Joaktive',
    total: 'Total',
    day: 'Dita',
    month: 'Muaji',
    year: 'Viti',
    week: 'Java',
    today: 'Sot',
    yesterday: 'Dje',
    noData: 'Nuk ka të dhëna',

    // Control (ekzistojnë)
    controlDatalogger: 'Kontroll Datalogger',
    controlSubtitle: 'Zgjidhni kompaninë, data logger dhe kontrollin.',
    selectDataLogger: 'Zgjidh data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Kontrolli',
    limitProduction: 'Kufizo prodhimin',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Mënyra reaktive (Q / PF)',
    current: 'Aktual',
    applyQ: 'Apliko Q',
    applyPF: 'Apliko PF',
    applyMode: 'Apliko mënyrën',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Lista e inverterëve',
    selectAll: 'Select All',
    noInverters: 'Nuk ka inverterë.',
    selectDataLoggerFirst: 'Zgjidh data logger.',

    // Dashboard
    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Shto një data logger për këtë kompani',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Përditësuar',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'në rrjedhje',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Energy Flow',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Dita',
    monthShort: 'Muaji',
    yearShort: 'Viti',
    thisMonth: 'Këtë Muaj',
    thisYear: 'Këtë Vit',
    totalProduction: 'Total Production',
    urgentAlarms: 'Alarmet urgjente',
    recentAlarms: 'Alarmet e fundit',
    environmentalImpact: 'Impakti Mjedisor',
    co2TodayLabel: 'CO₂ Sot',
    treeEquivalent: 'Ekuivalent Pemësh',
    photoUploadSuccess: 'Foto u ngarkua me sukses!',
    photoUploadError: 'Gabim gjatë ngarkimit',
    uploadLogo: 'Ngarko Logo',
    goBack: 'Kthehu',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Mbaj 3s mbi grafik për ndërruar ngjyrën',
    weatherStation: 'Stacioni i Motit (Solar)',
    radiation: 'Rrezatimi (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. modul',
    wind: 'Era',
    humidityPoa: 'Lagështia · POA (rrafshi i paneleve)',

    // Devices
    allDevices: 'Të Gjitha Pajisjet',
    inverterBattery: 'Inverter dhe Bateri',
    ems: 'EMS (Njehsor Energjie)',
    addDevice: 'Shto Pajisje',
    deviceData: 'Të dhënat e pajisjes',
    noDevices: 'Nuk ka pajisje',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Dita',
    weekLabel: 'Java',
    monthLabel: 'Muaji',
    yearLabel: 'Viti',
    lifetime: 'Gjithë Koha',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Ndrysho Pajisje',
    typeRequired: 'Lloji *',
    idRequired: 'ID *',
    select: 'Zgjidh...',
    brand: 'Brendi',
    selectBrand: 'Zgjidh brendin...',
    model: 'Modeli',
    ipAddress: 'IP Adresa',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Fuqia (kW) *',
    port: 'Port',
    unitId: 'Unit ID',
    s475DeviceIdLabel: 'ID e pajisjes',
    s475IdIsAlsoModbusUnit: 'I njëjti numër ruhet në Mongo si id dhe si unit_id Modbus — vendose si te pajisja.',
    photo: 'Foto',
    uploadPhoto: 'Ngarko Foto',
    uploadPhotoShort: '📷 Ngarko Foto',
    selectFile: 'Zgjidh skedar – Ngarko Foto',
    saving: 'Duke ruajtur...',
    idOnRaspberry: 'ID në Raspberry',
    power: 'Fuqia',
    noEdgeData: 'Nuk ka të dhëna edge ende.',
    confirmDeleteDatalogger: 'A je i sigurt? Data Logger dhe të gjithë inverterët/energy meterët e lidhur do të fshihen.',
    confirmDeleteDevice: 'A je i sigurt qe do me fshi pajisjen?',
    deviceDeleted: 'Pajisja u fshi!',
    connectionFailed: 'Lidhja me serverin dështoi...',
    deleteError: 'Gabim gjatë fshirjes',
    selectCompanyRequired: 'Zgjidh një kompani!',
    selectDataLoggerRequired: 'Zgjidh Data Logger!',
    deviceUpdated: 'Pajisja u përditësua!',
    deviceAdded: 'Pajisja u shtua!',
    photoNotLoggedIn: 'Foto: nuk je i kyçur ose token i skaduar. Dil dhe kyçu përsëri.',
    deviceTypeRequired: 'Lloji i Pajisjes *',
    selectType: 'Zgjidh llojin...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',

    // Alarms
    alarmSystem: 'Sistemi i Alarmeve',
    activeAlarms: 'Alarmet aktive',
    activeAlarmsList: 'Lista e alarmeve aktive në kohë reale',
    statusFromPi: 'Statusi nga Pi',
    alarmsFromInverters: 'Alarmet nga inverterët (Pi)',
    history: 'Historiku',
    alarmHistory: 'Historiku i alarmeve të mëparshme',
    notifications: 'Njoftimet',
    registerNotif: 'Regjistro email & SMS për njoftime',
    reportsSection: 'Raporte',
    alarmReports: 'Raporte të detajuara për alarme',
    activeOnly: 'Vetëm aktive',
    allDevicesFilter: 'Të gjitha pajisjet',
    noAlarms: 'Nuk ka alarme.',
    fromPi: 'Nga Pi',
    acknowledge: 'Pranoj',
    alarmStatusFromPi: 'Statusi i alarmeve nga çdo inverter (të dhënat e fundit nga Pi).',
    noInvertersData: 'Nuk ka inverterë ose nuk ka të dhëna.',
    noAlarmList: 'Nuk ka listë alarmesh.',
    noHistoricalData: 'Nuk ka të dhëna historike.',
    updatedLabel: 'Përditësuar',
    acknowledged: 'Pranuar',
    email: 'Email',
    emailPlaceholder: 'email@shembull.com',
    companyOptional: 'Kompani (opsional)',
    all: 'Të gjitha',
    registerNotifications: 'Regjistro njoftime',
    myRegistrations: 'Regjistrimet e mia',
    noRegistrations: 'Nuk keni regjistrime.',
    alarmReportsHint: 'Raporte të detajuara për alarme dhe energji mund të gjenerohen nga faqja Raportet.',
    openReports: 'Hap Raportet',
    registerError: 'Gabim gjatë regjistrimit.',
    alarmTabConfig: 'Konfigurimi DIO IoT Devices',
    alarmConfigDesc: 'Rregulla për pajisjet DIO IOT (S475): inpute 1–8, dalje DO0–3, faza L1–L3 (vlerat L1/L2/L3 nga lin).',
    alarmS475Source: 'S475',
    alarmReportSelectMonth: 'Muaji',
    alarmReportRefresh: 'Rifresko / ngarko',
    alarmReportTotalCount: 'Total alarmeve',
    alarmReportDownloadCsv: 'Shkarko CSV',
    alarmReportsIntro: 'Zgjidhni muajin dhe (opsionalisht) një pajisje për të parë të gjitha alarmet e atij muaji, me total dhe eksport CSV.',
    alarmCsvSeverity: 'Niveli',
    alarmCsvMessage: 'Mesazhi',
    alarmCsvRule: 'Rregulli',
    alarmCsvAckYes: 'Po',
    alarmCsvAckNo: 'Jo',
    minVoltageShort: 'Min (L)',
    maxVoltageShort: 'Max (L)',
    phaseLossShort: 'Humbje faze',
    windowMinutesShort: 'Minuta',
    saveAlarmRules: 'Ruaj rregullat',
    alarmRulesSaved: 'Rregullat u ruajtën.',
    phaseLinNote: 'Krahasohet me L1/L2/L3 në kW (lin) nga pajisja.',
    alarmCfgDinSubtitle: 'Hyrje digitale · dritarja e kohës së alarmit',
    alarmCfgDoSubtitle: 'Dalje digitale (DO0–DO3)',
    alarmCfgPhaseBlockSubtitle: 'Fazat · vlera në kW (lin)',
    alarmRuleEnable: 'Aktiv',

    // Reports
    reportsTitle: 'Raportet',
    reportsSubtitle: 'Gjenero dhe eksporto raporte të energjisë',
    generateReport: 'Gjenero Raport',
    totalReports: 'Total Raporte',
    daily: 'Ditore',
    monthly: 'Mujore',
    yearly: 'Vjetore',
    noReportsGenerated: 'Nuk ka raporte të gjeneruara',
    generateFirstReport: 'Gjeneroni raportin e parë për të parë statistikat',
    productionLabel: 'Prodhimi',
    consumption: 'Konsumi',
    sold: 'E Shitur',
    revenue: 'Të Ardhura',
    pdf: 'PDF',
    generateNewReport: 'Gjenero Raport të Ri',
    reportType: 'Tipi i Raportit',
    checkinReport: 'Raporti check-in',
    reportKwh: 'Raporti kWh',
    reportInputeve: 'Raporti inputeve',
    reportFuel: 'Raporti i naftës',
    reportGeneral: 'Raporti i përgjithshëm',
    reportMonthPrevious: 'Muaji paraprak',
    reportMonthCurrent: 'Muaji aktual',
    generalColCheckin: 'Check-in',
    generalColCheckout: 'Check-out',
    generalColKm: 'km',
    generalColEstLiters: 'Naftë e vlerësuar (L)',
    generalColRemainingLiters: 'Mbetja (L) kum.',
    generalColTrackedGenHours: 'Orë gjenerator (input)',
    generalReportPickDeviceKwh: 'Për kolonën kWh në tabelë, zgjidhni një pajisje.',
    generatorLitersPerHour: 'Gjeneratori l/h',
    generatorTrackingDin: 'Gjurmimi i gjeneratorit',
    generatorTrackingDin0: 'DIN0',
    generatorTrackingDin1: 'DIN1',
    reportTimeIn: 'Ora IN',
    reportTimeOut: 'Ora OUT',
    generalKwhLoadFailed: 'kWh për këtë pajisje nuk u ngarkua; tabela tregon check-in dhe naftë.',
    dayColumn: 'Dita',
    kwhColumn: 'kWh',
    downloadExcel: 'Shkarko Excel (CSV)',
    checkinCountLabel: 'Check-in',
    checkoutCountLabel: 'Check-out',
    eventTypeColumn: 'Lloji',
    checkinEventLabel: 'Check-in',
    checkoutEventLabel: 'Checkout',
    fuelLitersColumn: 'Naftë (L)',
    partsColumn: 'Produkti',
    commentColumn: 'Koment',
    noFuelReportData: 'Nuk ka regjistrime me naftë, copë ose koment për këtë periudhë.',
    viewReport: 'Shiko raportin',
    noCheckinDataForPeriod: 'Nuk ka të dhëna check-in për këtë periudhë dhe zgjedhje.',
    downloadPdf: 'Shkarko PDF',
    dateAndTime: 'Data dhe ora',
    reportInputsTitle: 'Raporti inputeve (DIN)',
    inputColumn: 'Inputi',
    minutesOn: 'Minuta ON',
    hoursOn: 'Orë ON',
    minutesOff: 'Minuta OFF',
    hoursOff: 'Orë OFF',
    noDataStoredPeriod: 'Nuk ka të dhëna të ruajtura për këtë periudhë.',
    noInputsDataMessage: 'Nuk ka të dhëna. Inputet do të shfaqen kur të ruhen leximet.',
    selectDateRange: 'Zgjidhni datën nga dhe deri.',
    totalKwh: 'Total',
    startDate: 'Fillimi',
    endDate: 'Fundi',
    generating: 'Duke gjeneruar...',
    generate: 'Gjenero',
    reportGenerated: 'Raporti u gjenerua.',
    reportError: 'Gabim gjatë gjenerimit të raportit.',
    dailyReport: 'Ditor',
    weeklyReport: 'Javor',
    monthlyReport: 'Mujor',
    yearlyReport: 'Vjetor',
    companyLabel: 'Kompania',
    energyReport: 'Raport i Energjisë',
    period: 'Periudha',
    metric: 'Metrika',
    value: 'Vlera',
    totalProductionLabel: 'Prodhimi Total',
    totalConsumption: 'Konsumi Total',
    energySold: 'Energjia e Shitur',
    totalRevenue: 'Të Ardhurat Totale',

    // Kosova
    kosovaTitle: 'Kosova – Të dhënat e fundit',
    checkingConnection: 'Duke kontrolluar lidhjen...',
    kosovaNotConnected: 'Kosova nuk është e lidhur',
    kosovaNotConnectedHint: 'Kosova (Raspberry) nuk është e lidhur. Hapini tunelin SSH.',
    sshTunnelHint: 'Në VPS ekzekutoni tunelin:',
    inverterLastRead: 'Inverter (leximi i fundit)',
    dataloggerLastRead: 'Data logger (leximi i fundit)',
    energyMeterLastRead: 'Njehsor energjie (leximi i fundit)',
    alarmsLast10: 'Alarmet (10 të fundit)',
    deviceStatus: 'Statusi pajisjes',
    dailyEnergy: 'Energji ditore (kWh)',
    totalEnergy: 'Energji totale',

    // Analysis
    energyManagement: 'Menaxhimi i Energjisë',
    energy: 'Energjia',
    energyAnalysis: 'Analiza e Energjisë',
    consumptionAnalysis: 'Analiza e Konsumit',
    revenueAnalysis: 'Analiza e të Ardhurave',
    benefits: 'Përfitimet',
    selectDates: 'Zgjidh Datat',
    energyBalance: 'Bilanci i Energjisë',
    selfConsumption: 'Vetë-Konsumi',
    exportLabel: 'Eksporti',
    selfSufficiency: 'Vetë-Mjaftueshmëria',
    buyFromGrid: 'Blerja nga Rrjeti',
    supply: 'Furnizimi (kW)',
    usage: 'Përdorimi',
    loads: 'Ngarkesa',
    network: 'Rrjeti',
    solarGen: 'Diellore',
    generation: 'Gjenerimi',
    imported: 'Importuar',
    pvProduced: 'PV Prodhuar',
    discharged: 'Shkarkuar',
    exported: 'Eksportuar',
    consumed: 'Konsumuar',
    charged: 'Ngarkuar',
    selectPeriod: 'Zgjidh Periudhën',
    fromDate: 'Nga Data',
    toDate: 'Deri në Datën',

    // ProductionPlanning
    productionPlanning: 'Planifikimi i Prodhimit',
    selectDate: 'Data (kalendar për historik)',
    selectCompanyForData: 'Zgjidhni një kompani për të parë të dhënat.',
    selectDateAndSearch: 'Zgjidhni një datë (ose Dje) dhe klikoni Kerko.',
    clickSearchHint: 'Klikoni Kerko për të kërkuar të dhënat për {date}.',
    loadingData: 'Duke ngarkuar të dhënat...',
    noEnergyMeters: 'Nuk ka energy meterë për këtë kompani.',
    weatherHint: 'Të dhënat e motit (GHI, temp, erë) do të shfaqen kur instaloni weather station.',
    hour: 'Ora',
    emProduction: 'EM Prodhimi (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Ndryshimi (EM−DL)',
    radiationGhi: 'Rrezatimi (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. modul °C',
    windSpeed: 'Era (m/s)',
    weatherOnlyHint: 'Vetëm moti (Open-Meteo). Prodhimi do të shfaqet kur instaloni energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Ndryshimi = EM − DL (pozitiv = meter më shumë se datalogger, negativ = datalogger më shumë).',
    data: 'Data',
    productionAndWeatherHourly: 'Prodhimi dhe moti për orë (05:00–20:00)',

    // Companies
    companiesTitle: 'Kompanit',
    companiesSubtitle: 'Menaxho kompanitë dhe të dhënat',
    setDashboardPhoto: 'Vendos foton e dashboard-it për të gjitha',
    setting: 'Duke vendosur...',
    addCompany: '+ Shto Kompani',
    totalCompanies: 'Total Kompani',
    noCompaniesRegistered: 'Nuk ka kompani të regjistruara',
    addFirstCompany: 'Shtoni kompaninë e parë për të filluar',
    logo: 'Logo',
    companyName: 'Emri i kompanisë',
    address: 'Adresa',
    phone: 'Telefoni',
    website: 'Website',
    uniqueNr: 'Nr. Unik',
    vatNr: 'Nr. TVSH',
    hold3sForLogo: 'Mbaj shtypur 3 sekonda për të ngarkuar logo (PNG)',
    editCompany: 'Ndrysho Kompaninë',
    addNewCompany: 'Shto Kompani të Re',
    dashboardPhoto: 'Foto e dashboard-it (opsionale)',
    dashboardPhotoHint: 'Çdo kompani e ka foton e vet në faqen e parë (dashboard)...',
    selectDashboardPhoto: 'Zgjidh foton e dashboard-it',
    companyNameRequired: 'Emri i kompanisë *',
    selectPhoto: 'Zgjidh një foto PNG...',
    selectImage: 'Zgjidh Foto',
    pngOnly: 'Lejohet vetëm skedar PNG (.png).',
    confirmDeleteCompany: 'A jeni të sigurt që dëshironi të fshini këtë kompani?',
    confirmSeedDashboardPhotos: 'Vendos foton e dashboard-it (company_comp-frigofood_aa3a78e3) për të gjitha kompanitë? Më vonë mund ta ndryshoni nga modali "Ndrysho Kompaninë".',
    logoUploaded: 'Logo u ngarkua me sukses!',
    uploadError: 'Gabim gjatë ngarkimit',
    imagesOnly: 'Lejohen vetëm imazhe: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Fotoja e dashboard-it u ngarkua me sukses!',
    companySaveError: 'Gabim gjatë ruajtjes së kompanisë.',
    deleteCompanyError: 'Gabim gjatë fshirjes së kompanisë.',

    // Users
    usersTitle: 'Përdoruesit',
    addUser: '+ Shto Përdorues',
    ensureBackendRunning: 'Sigurohuni që backend-i (FastAPI) është i ndezur në portin 8000.',
    tryAgain: 'Provë përsëri',
    closeMessage: 'Mbylle',
    closeMessageAria: 'Mbylle mesazhin',
    name: 'Emri',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Kompania',
    editUser: 'Ndrysho Përdoruesin',
    addNewUser: 'Shto Përdorues të Ri',
    fullName: 'Emër Mbiemër',
    fullNameAlt: 'Emri Mbiemri',
    passwordOptional: 'Fjalëkalimi (opsional)',
    role: 'Role',
    navigation: 'Navigimi',
    selectCompanyUsers: 'Zgjidh Kompanin',
    allowedNavigation: 'Navigimi i Lejuar',
    none: 'Asnjë',
    companiesCount: 'kompani',
    pages: 'faqe',
    allOption: 'Të gjitha',
    confirmDeleteUser: 'A jeni të sigurt që dëshironi të fshini këtë përdorues?',
    saveError: 'Gabim gjatë ruajtjes.',
    deleteUserError: 'Gabim gjatë fshirjes.',

    // DataLoggerDetail
    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    totalProductionLabel: 'Prodhimi Total',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    // InverterDetail
    inverterNotFound: 'Inverteri nuk u gjet',
    inverterDetails: 'Detajet e Inverterit',
    statusAndEnergy: 'Statusi & Energjia',
    power: 'Fuqia',
    pvVoltage: 'Tensioni PV',
    pvCurrent: 'Rryma PV',
    gridAndPhase: 'Rrjeti & Faza',
    system: 'Sistemi',
    pvPower: 'Fuqia PV',
    todayPvYield: 'Prodhimi sot PV',
    totalPvYield: 'Prodhimi total PV',
    monthlyPvYield: 'Prodhimi mujor PV',
    energyAnalysis: 'Analiza e Energjisë',
    details: 'Detajet',
    realTime: 'Kohë Reale',
    alarms: 'Alarmet',
    realtimeCurve: 'Lakorja në kohë reale',
    deviceStatus: 'Statusi i pajisjes',
    energyYieldCurrentDay: 'Energjia e ditës aktuale',
    totalEnergyYield: 'Energjia totale',
    reducedCo2Emission: 'CO₂ i reduktuar',
    dcPower: 'Fuqia DC',
    activePower: 'Fuqia aktive',
    reactivePower: 'Fuqia reaktive',
    powerFactor: 'Faktori i fuqisë',
    gridAbBcCaVoltage: 'Tensioni rrjeti AB/BC/CA',
    gridAbcPhaseCurrent: 'Rryma fazore A/B/C',
    todayPeakActivePower: 'Fuqia kulmore sot',
    gridFrequency: 'Frekuenca e rrjetit',
    locking: 'Kyçja',
    cabinetTemperature: 'Temp. kabineti',
    startupTime: 'Koha e fillimit',
    shutdownTime: 'Koha e ndaljes',
    collectDspData: 'Mbledhja e të dhënave DSP',
    activePowerAdjustment: 'Rregullimi i fuqisë aktive',
    reactivePowerAdjustment: 'Rregullimi i fuqisë reaktive',
    pv18Voltage: 'PV1-8 tension',
    pv916Voltage: 'PV9-16 tension',
    pv1724Voltage: 'PV17-24 tension',
    pv2528Voltage: 'PV25-28 tension',
    pv18Current: 'PV1-8 rrymë',
    pv916Current: 'PV9-16 rrymë',
    pv1724Current: 'PV17-24 rrymë',
    pv2528Current: 'PV25-28 rrymë',
    allDevices: 'Të Gjitha Pajisjet',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'Nuk ka alarme.',

    // EnergyMeterDetail
    energyMeterNotFound: 'Njehsor energjie nuk u gjet',
    alarmHistoryLabel: 'Historiku i Alarmave',
    activeAlarmsLabel: 'Alarmet Aktive',
    noActiveAlarms: 'Nuk ka alarme aktive.',
    noAlarms: 'Nuk ka alarme.',
    activePowerReal: 'Fuqia Aktive (Fuqia Reale)',
    todayEnergy: 'Energjia Sot',
    monthlyEnergy: 'Energjia Mujore (1–31)',
    totalEnergyLabel: 'Energjia Totale',
    meterDetails: 'Detajet e Njehsorit',
    energyAnalysisLabel: 'Analiza e Energjisë',
    inOut: 'Hy-Dil',
    photoUpload: 'Ngarko Foto',
    photoUploadFor: 'Ngarko Foto për',
    selectPhoto: 'Zgjidh Foto',
    exportLabel: 'Eksport',
    totalLabel: 'Total',
    emSectionPower: 'Fuqia',
    emSectionEnergy: 'Energjia',
    emSectionVoltage: 'Tensioni',
    emSectionCurrent: 'Rryma',
    emSectionFrequency: 'Frekuenca',
    emSectionDemand: 'Kërkesa (Peak)',
    emSectionAdvanced: 'Avancuar',
    digitalIO: 'I/O Digjitale',
    inputs: 'Inpute',
    outputs: 'Outpute (mban >5s për shkrim)',
    figureScheme: 'Figurë / Skemë',
    verifyPayload: 'Verifiko payload (raw nga API)',
    writeDO: 'Shkruaj DO1/DO2',
    confirmStopStart: 'A je i sigurt? Don me ndal apo me dhez?',
    send: 'Dërgo',

    // DetailedParameters / Inverter Param Sections
    detailedParameters: 'Parametrat e Detajuar',
    pvInfo: 'Informacioni PV',
    voltage: 'Tensioni (V)',
    currentLabel: 'Rryma (A)',
    powerLabel: 'Fuqia (kW)',
    acInfo: 'Informacioni AC',
    frequency: 'Frekuenca (Hz)',
    gridInfo: 'Informacioni i Rrjetit',
    gridStatus: 'Statusi i Rrjetit',
    loadInfo: 'Informacioni i Ngarkesës',
    gridPower: 'Fuqia e Rrjetit',
    acVoltage: 'Tensioni AC',
    acCurrent: 'Rryma AC',
    acFrequency: 'Frekuenca AC',
    loadPower: 'Fuqia e Ngarkesës',
    loadCurrent: 'Rryma e Ngarkesës',
    pv1Voltage: 'Tensioni PV1',
    pv1Current: 'Rryma PV1',
    pv2Voltage: 'Tensioni PV2',
    pv2Current: 'Rryma PV2',
    dlInputPowerDc: 'Fuqia Hyrëse / DC',
    dlGridPhaseCurrents: 'Rrymat Fazore të Rrjetit',
    dlLockStatus: 'Statusi i Kyçjes',
    dlReactiveAdjustmentLimits: 'Kufijtë e Rregullimit Reaktiv',
    dlActiveAdjustmentLimits: 'Kufijtë e Rregullimit Aktiv',
    dlPvReactiveLimits: 'Kufijtë Reaktivë PV',
    dlEssReactiveLimits: 'Kufijtë Reaktivë ESS',
    dlPvActiveLimit: 'Kufiri Aktiv PV',
    dlEssPeaks: 'Kulmet ESS',
    dlApiOverrideStatuses: 'Statuset e Anashkalimit të API',
    dlRemoteScheduling: 'Planifikimi nga largësia',
    dlKpi: 'KPI',
    dlInputPowerKw: 'Fuqia hyrëse (kW)',
    dlDcCurrentA: 'Rryma DC (A)',
    dlGridAPhaseCurrent: 'Rryma fazore A (A)',
    dlGridBPhaseCurrent: 'Rryma fazore B (A)',
    dlGridCPhaseCurrent: 'Rryma fazore C (A)',
    dlLockStatusLabel: 'Statusi i kyçjes',
    dlReducedCo2Kg: 'CO₂ i reduktuar (kg)',
    dlMaxReactiveAdj: 'Vlera maks. për rregullim reaktiv (kVar)',
    dlMinReactiveAdj: 'Vlera min. për rregullim reaktiv (kVar)',
    dlMaxActiveAdj: 'Vlera maks. për rregullim aktiv (kW)',
    dlMinActiveAdj: 'Vlera min. për rregullim aktiv (kW)',
    dlPvReactiveMax: 'Vlera më e lartë reaktive PV (kVar)',
    dlPvReactiveMin: 'Vlera më e ulët reaktive PV (kVar)',
    dlEssReactiveMax: 'Vlera më e lartë reaktive ESS (kVar)',
    dlEssReactiveMin: 'Vlera më e ulët reaktive ESS (kVar)',
    dlPvActiveMax: 'Vlera më e lartë aktive PV (kW)',
    dlEssDischargeMax: 'Fuqia maksimale shkarkimi ESS (kW)',
    dlEssChargeMax: 'Fuqia maksimale ngarkimi ESS (kW)',
    dlApiActiveOverride: 'API aktive me përparësi të ulët të anashkaluara',
    dlApiReactiveOverride: 'API reaktive me përparësi të ulët të anashkaluara',
    dlRemoteSchedP: 'Planifikim komunikimi nga largësia (P)',
    dlRemoteSchedQ: 'Planifikim komunikimi nga largësia (Q)',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',

    // Dashboard S475, S475Detail, Check-in, Companies, MeSettings, Notification, ChangePassword
    selectCompanyPlaceholder: 'Zgjidhni kompaninë',
    selectLocationPlaceholder: 'Zgjidhni lokacionin',
    connectionError: 'Gabim lidhjeje',
    writeError: 'Gabim gjatë shkrimit',
    lastUpdated: 'E fundit përditësuar',
    clickToChange: 'Kliko për ndryshim',
    selectDevicePlaceholder: 'Zgjidhni një paisje',
    backToDevices: 'Kthehu te Pajisjet',
    deviceNotFound: 'Paisja nuk u gjet.',
    configForDashboard: 'Konfigurim për Dashboard',
    selected: 'Zgjedhur',
    clickToSelect: 'Kliko për zgjedhje',
    errorSaving: 'Gabim gjatë ruajtjes',
    selectLocationHint: 'Zgjidhni lokacionin ku ndodheni (p.sh. Boge, Mitrovicë).',
    loadingLocations: 'Duke ngarkuar lokacionet…',
    noLocations: 'Nuk ka lokacione të disponueshme.',
    openCameraAndPhoto: 'Hap kamerën dhe bëj foto',
    capturePhoto: 'Kap foto',
    locationLabel: 'Lokacioni',
    retake: 'Rikap',
    confirmCheckin: 'Konfirmo check-in',
    lastCheckins5: 'Check-in e fundit (5)',
    lastCheckins10: 'Check-in e fundit (10)',
    noCheckinsYet: 'Ende nuk ka check-in. Zgjidhni lokacionin dhe bëni foto për të regjistruar.',
    dateTimeColumn: 'Data / Ora',
    photoColumn: 'Foto',
    viewPhotoLarge: 'Shiko foton e madhe',
    checkinFailed: 'Check-in dështoi',
    checkinSuccessToast: 'Check-in u regjistrua.',
    checkoutSuccess: 'Checkout u regjistrua.',
    checkoutCommentRequired: 'Për checkout shkruani komentin (çfarë u rregullua / gjendja) para fotos.',
    checkoutCommentPrefilledHint: 'Komenti u mbush nga vizita (modal «Shtesa»). Mund ta ndryshoni para kamerës.',
    checkoutCommentReminder: 'Komenti për checkout',
    checkoutButton: 'Checkout (foto + koment)',
    checkoutStepTitle: 'Hapi 1: komenti për checkout',
    continueToCamera: 'Vazhdo te kamera',
    addFuelRowButton: 'Shto naftë / copë',
    addFuelPlusColumn: '+',
    addFuelAria: 'Shto naftë ose produkt për këtë vizitë',
    fuelModalTitle: 'Shtesa për vizitën (check-in i fundit)',
    saveFuelButton: 'Ruaj',
    litersFuelPlaceholder: 'Litra naftë (numër)',
    partsCountPlaceholder: 'Copë / siguresa (numër i plotë)',
    productFieldLabel: 'Produkti',
    fuelModalCommentOptional: 'Koment (opsional) për vizitën',
    commentRepairPlaceholder: 'Komenti: çfarë u rregullua',
    fuelSavedToast: 'Të dhënat u ruajtën.',
    fuelInvalidLiters: 'Litra naftë: vendosni një numër të vlefshëm (ose lëreni bosh).',
    fuelInvalidParts: 'Produkti: vendosni një numër të plotë (ose lëreni bosh).',
    eventKindCheckin: 'Check-in',
    eventKindCheckout: 'Checkout',
    cameraError: 'Kamera nuk u hap',
    confirmDeleteTitle: 'Konfirmo fshirjen',
    selectLogo: 'Zgjidh logo',
    companyNamePlaceholder: 'Emri i kompanisë',
    languageLabel: 'Gjuha',
    darkLightMode: 'Mënyra e errët / e ndritur',
    darkMode: 'E errët',
    lightMode: 'E ndritur',
    langShqip: 'Shqip',
    langEnglish: 'English',
    currentPasswordLabel: 'Fjalëkalimi aktual',
    newPasswordLabel: 'Fjalëkalimi i ri',
    confirmNewPasswordLabel: 'Konfirmo fjalëkalimin e ri',
    currentPasswordRequired: 'Vendosni fjalëkalimin aktual.',
    newPasswordMinLength: 'Fjalëkalimi i ri duhet të ketë të paktën 4 karaktere.',
    passwordsDoNotMatch: 'Fjalëkalimi i ri dhe konfirmimi nuk përputhen.',
    passwordChangedSuccess: 'Fjalëkalimi u ndryshua.',
    passwordChangeError: 'Nuk u ndryshua fjalëkalimi.',
    notificationsTitle: 'Njoftimet',
    selectDevice: 'Zgjidhni pajisjen',
    saveNotifications: 'Ruaj',
    testEmail: 'Dërgo email test',
    notificationSelectDeviceHint: 'Zgjidhni pajisjen dhe aktivizoni Push dhe/ose Email për çdo lloj njoftimi.',
    deviceLabel: 'Pajisja',
    testEmailFailed: 'Email test dështoi.',
    notificationFooter: 'Njoftimet dërgohen në email-in e llogarisë tuaj dhe si push në pajisjen ku keni aktivizuar njoftimet.',
    notificationsAlarmsTitle: 'Alarmet',
    notificationsSuperConfigHint: 'Për njoftime Push/Email, hapni Cilësimet e sistemit (zgjedhja e pajisjes atje).',
    noAlarmsInList: 'Nuk ka alarme për këtë filtrim.',
    alarmActiveBadge: 'Aktiv',
    reportsSuperAdminOnly: 'Raportet check-in dhe naftë janë vetëm për super administrator.',
    reportSessionIn: 'Hyrje',
    reportSessionOut: 'Dalje',
    reportWorkHoursColumn: 'Orë pune',
    reportTotalWorkHours: 'Total orë pune',
    deviceNotifSectionTitle: 'Njoftime Push / Email (pajisja kjo)',
    deviceNotifSectionDesc: 'Aktivizoni kanalet për alarmet e kësaj pajisje. Ruani pas ndryshimeve.',
    deviceNotifTestEmail: 'Dërgo email test',
    deviceNotifSaved: 'Preferencat e njoftimeve u ruajtën.',
    deviceNotifTestOk: 'Email test u dërgua.',
    deviceNotifTestFail: 'Email test dështoi.',
    push: 'Push',
    emailNotif: 'Email',
    valuesNotReading: 'Nuk lexohen vlerat',
    doSetTo: 'u vendos në',
    lastLabel: 'E fundit',
    voltDc: 'Volt DC',
    tempChannel: 'Temperatura',
    humidityChannel: 'Lagështia',
    totalKwChannel: 'Total kW',
    frequencyChannel: 'Frekuenca',
  },
  en: {
    logout: 'Logout',
    more: 'More',
    home: 'Dashboard',
    devices: 'Devices',
    checkin: 'Check-in',
    alarms: 'Alarms',
    reports: 'Reports',
    kosova: 'Kosova',
    analysis: 'Analysis',
    analizat: 'Analysis',
    planning: 'Planning',
    control: 'Control',
    companies: 'Companies',
    users: 'Users',
    me: 'Me',

    report: 'Report',
    faults: 'Faults',
    links: 'Links',
    about: 'About',
    systemSettings: 'System Settings',
    changePassword: 'Change Password',
    notification: 'Notification',
    konfigurimi: 'Configuration',
    statusOk: 'OK – running',
    statusStopped: 'Stopped',
    statusActivating: 'Starting (activating)…',
    statusFailed: 'Failed',
    serverStopped: 'Server stopped',
    noPermission: 'You do not have permission',
    noServers: 'No servers found.',
    back: 'Back',
    ...Object.fromEntries(Array.from({ length: 13 }, (_, i) => [`server${i + 1}`, `Server ${i + 1}`])),
    contactUs: 'Contact Us',
    version: 'Version',

    loginTitle: 'Login',
    loginSubtitle: 'Enter your credentials to continue',
    username: 'Username',
    passwordLabel: 'Password',
    rememberCreds: 'Remember credentials',
    loginBtn: 'Login',
    loggingIn: 'Logging in...',
    errorNetwork: 'Connection to server failed.',
    errorLogin: 'Login error. Please try again.',
    toggleThemeLabel: 'Toggle light/dark',

    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    apply: 'Apply',
    search: 'Search',
    back: 'Back',
    confirm: 'Are you sure?',
    errorGeneric: 'Error',
    password: 'Password',
    confirmCheck: 'Confirm',
    execute: 'Execute',
    sending: 'Sending...',
    noCompanies: 'No companies',
    selectCompany: 'Select company',
    selectCompanyFirst: 'Select a company.',
    company: 'Company',
    dataLogger: 'Data Logger',
    dataLoggers: 'Data Logger',
    inverter: 'Inverter',
    inverters: 'Inverters',
    energyMeter: 'Energy Meter',
    energyMeters: 'Energy Meters',
    status: 'Status',
    type: 'Type',
    actions: 'Actions',
    online: 'Online',
    offline: 'Offline',
    partial: 'Partial',
    normal: 'Normal',
    active: 'Active',
    inactive: 'Inactive',
    total: 'Total',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    week: 'Week',
    today: 'Today',
    yesterday: 'Yesterday',
    noData: 'No data',

    controlDatalogger: 'Control Datalogger',
    controlSubtitle: 'Select company, data logger and control.',
    selectDataLogger: 'Select data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Control',
    limitProduction: 'Limit production',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Reactive mode (Q / PF)',
    current: 'Current',
    applyQ: 'Apply Q',
    applyPF: 'Apply PF',
    applyMode: 'Apply mode',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Inverter list',
    selectAll: 'Select All',
    noInverters: 'No inverters.',
    selectDataLoggerFirst: 'Select data logger.',

    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Add a data logger for this company',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Updated',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'flowing',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Energy Flow',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Day',
    monthShort: 'Month',
    yearShort: 'Year',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    totalProduction: 'Total Production',
    urgentAlarms: 'Urgent alarms',
    recentAlarms: 'Recent alarms',
    environmentalImpact: 'Environmental Impact',
    co2TodayLabel: 'CO₂ Today',
    treeEquivalent: 'Tree Equivalent',
    photoUploadSuccess: 'Photo uploaded successfully!',
    photoUploadError: 'Upload error',
    uploadLogo: 'Upload Logo',
    goBack: 'Go Back',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Hold 3s on chart to change color',
    weatherStation: 'Weather Station (Solar)',
    radiation: 'Radiation (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. module',
    wind: 'Wind',
    humidityPoa: 'Humidity · POA (panel plane)',

    allDevices: 'All Devices',
    inverterBattery: 'Inverter & Battery',
    ems: 'EMS (Energy Meter)',
    addDevice: 'Add Device',
    deviceData: 'Device data',
    noDevices: 'No devices',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Day',
    weekLabel: 'Week',
    monthLabel: 'Month',
    yearLabel: 'Year',
    lifetime: 'Lifetime',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Edit Device',
    typeRequired: 'Type *',
    idRequired: 'ID *',
    select: 'Select...',
    brand: 'Brand',
    selectBrand: 'Select brand...',
    model: 'Model',
    ipAddress: 'IP Address',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Power (kW) *',
    port: 'Port',
    unitId: 'Unit ID',
    s475DeviceIdLabel: 'Device ID',
    s475IdIsAlsoModbusUnit: 'Same number is stored as id and Modbus unit_id — must match the device.',
    photo: 'Photo',
    uploadPhoto: 'Upload Photo',
    uploadPhotoShort: '📷 Upload Photo',
    selectFile: 'Select file – Upload Photo',
    saving: 'Saving...',
    idOnRaspberry: 'ID on Raspberry',
    power: 'Power',
    noEdgeData: 'No edge data yet.',
    confirmDeleteDatalogger: 'Are you sure? Data Logger and all connected inverters/energy meters will be deleted.',
    confirmDeleteDevice: 'Are you sure you want to delete this device?',
    deviceDeleted: 'Device deleted!',
    connectionFailed: 'Connection to server failed...',
    deleteError: 'Delete error',
    selectCompanyRequired: 'Select a company!',
    selectDataLoggerRequired: 'Select Data Logger!',
    deviceUpdated: 'Device updated!',
    deviceAdded: 'Device added!',
    photoNotLoggedIn: 'Photo: you are not logged in or token expired. Logout and login again.',
    deviceTypeRequired: 'Device Type *',
    selectType: 'Select type...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',

    alarmSystem: 'Alarm System',
    activeAlarms: 'Active alarms',
    activeAlarmsList: 'List of active alarms in real time',
    statusFromPi: 'Status from Pi',
    alarmsFromInverters: 'Alarms from inverters (Pi)',
    history: 'History',
    alarmHistory: 'History of previous alarms',
    notifications: 'Notifications',
    registerNotif: 'Register email & SMS for notifications',
    reportsSection: 'Reports',
    alarmReports: 'Detailed reports for alarms',
    activeOnly: 'Active only',
    allDevicesFilter: 'All devices',
    noAlarms: 'No alarms.',
    fromPi: 'From Pi',
    acknowledge: 'Acknowledge',
    alarmStatusFromPi: 'Alarm status from each inverter (latest data from Pi).',
    noInvertersData: 'No inverters or no data.',
    noAlarmList: 'No alarm list.',
    noHistoricalData: 'No historical data.',
    updatedLabel: 'Updated',
    acknowledged: 'Acknowledged',
    email: 'Email',
    emailPlaceholder: 'email@example.com',
    companyOptional: 'Company (optional)',
    all: 'All',
    registerNotifications: 'Register notifications',
    myRegistrations: 'My registrations',
    noRegistrations: 'No registrations.',
    alarmReportsHint: 'Detailed reports for alarms and energy can be generated from the Reports page.',
    openReports: 'Open Reports',
    registerError: 'Registration error.',
    alarmTabConfig: 'DIO IoT Devices configuration',
    alarmConfigDesc: 'Rules for DIO IOT (S475) devices: inputs 1–8, outputs DO0–3, phases L1–L3 (uses L1/L2/L3 from lin).',
    alarmS475Source: 'S475',
    alarmReportSelectMonth: 'Month',
    alarmReportRefresh: 'Refresh / load',
    alarmReportTotalCount: 'Total alarms',
    alarmReportDownloadCsv: 'Download CSV',
    alarmReportsIntro: 'Pick a month and optionally a device to list all alarms in that month, with total count and CSV export.',
    alarmCsvSeverity: 'Severity',
    alarmCsvMessage: 'Message',
    alarmCsvRule: 'Rule',
    alarmCsvAckYes: 'Yes',
    alarmCsvAckNo: 'No',
    minVoltageShort: 'Min (L)',
    maxVoltageShort: 'Max (L)',
    phaseLossShort: 'Phase loss',
    windowMinutesShort: 'Minutes',
    saveAlarmRules: 'Save rules',
    alarmRulesSaved: 'Rules saved.',
    phaseLinNote: 'Compared to L1/L2/L3 (lin kW) from the device.',
    alarmCfgDinSubtitle: 'Digital inputs · alarm time window',
    alarmCfgDoSubtitle: 'Digital outputs (DO0–DO3)',
    alarmCfgPhaseBlockSubtitle: 'Phases · values in kW (lin)',
    alarmRuleEnable: 'Active',

    reportsTitle: 'Reports',
    reportsSubtitle: 'Generate and export energy reports',
    generateReport: 'Generate Report',
    totalReports: 'Total Reports',
    daily: 'Daily',
    monthly: 'Monthly',
    yearly: 'Yearly',
    noReportsGenerated: 'No reports generated',
    generateFirstReport: 'Generate the first report to see statistics',
    productionLabel: 'Production',
    consumption: 'Consumption',
    sold: 'Sold',
    revenue: 'Revenue',
    pdf: 'PDF',
    generateNewReport: 'Generate New Report',
    reportType: 'Report Type',
    checkinReport: 'Check-in report',
    reportKwh: 'kWh report',
    reportInputeve: 'Inputs report',
    reportFuel: 'Fuel report',
    reportGeneral: 'General report',
    reportMonthPrevious: 'Previous month',
    reportMonthCurrent: 'Current month',
    generalColCheckin: 'Check-ins',
    generalColCheckout: 'Check-outs',
    generalColKm: 'km',
    generalColEstLiters: 'Estimated fuel (L)',
    generalColRemainingLiters: 'Remaining (L) cumul.',
    generalColTrackedGenHours: 'Generator hours (input)',
    generalReportPickDeviceKwh: 'Select a device to include the kWh column.',
    generatorLitersPerHour: 'Generator L/h',
    generatorTrackingDin: 'Generator tracking input',
    generatorTrackingDin0: 'DIN0',
    generatorTrackingDin1: 'DIN1',
    reportTimeIn: 'Time IN',
    reportTimeOut: 'Time OUT',
    generalKwhLoadFailed: 'Could not load kWh for this device; the table still shows check-ins and fuel.',
    dayColumn: 'Day',
    kwhColumn: 'kWh',
    downloadExcel: 'Download Excel (CSV)',
    checkinCountLabel: 'Check-ins',
    checkoutCountLabel: 'Check-outs',
    eventTypeColumn: 'Type',
    checkinEventLabel: 'Check-in',
    checkoutEventLabel: 'Checkout',
    fuelLitersColumn: 'Fuel (L)',
    partsColumn: 'Product',
    commentColumn: 'Comment',
    noFuelReportData: 'No fuel, parts, or comment records for this period.',
    viewReport: 'View report',
    noCheckinDataForPeriod: 'No check-in data for this period and selection.',
    downloadPdf: 'Download PDF',
    dateAndTime: 'Date and time',
    reportInputsTitle: 'Inputs report (DIN)',
    inputColumn: 'Input',
    minutesOn: 'Minutes ON',
    hoursOn: 'Hours ON',
    minutesOff: 'Minutes OFF',
    hoursOff: 'Hours OFF',
    noDataStoredPeriod: 'No data stored for this period.',
    noInputsDataMessage: 'No data. Inputs will appear when readings are stored.',
    selectDateRange: 'Select from and to date.',
    totalKwh: 'Total',
    startDate: 'Start',
    endDate: 'End',
    generating: 'Generating...',
    generate: 'Generate',
    reportGenerated: 'Report generated.',
    reportError: 'Error generating report.',
    dailyReport: 'Daily',
    weeklyReport: 'Weekly',
    monthlyReport: 'Monthly',
    yearlyReport: 'Yearly',
    companyLabel: 'Company',
    energyReport: 'Energy Report',
    period: 'Period',
    metric: 'Metric',
    value: 'Value',
    totalProductionLabel: 'Total Production',
    totalConsumption: 'Total Consumption',
    energySold: 'Energy Sold',
    totalRevenue: 'Total Revenue',

    kosovaTitle: 'Kosova – Latest data',
    checkingConnection: 'Checking connection...',
    kosovaNotConnected: 'Kosova is not connected',
    kosovaNotConnectedHint: 'Kosova (Raspberry) is not connected. Open SSH tunnel.',
    sshTunnelHint: 'On VPS run the tunnel:',
    inverterLastRead: 'Inverter (last reading)',
    dataloggerLastRead: 'Data logger (last reading)',
    energyMeterLastRead: 'Energy meter (last reading)',
    alarmsLast10: 'Alarms (last 10)',
    deviceStatus: 'Device status',
    dailyEnergy: 'Daily energy (kWh)',
    totalEnergy: 'Total energy',

    energyManagement: 'Energy Management',
    energy: 'Energy',
    energyAnalysis: 'Energy Analysis',
    consumptionAnalysis: 'Consumption Analysis',
    revenueAnalysis: 'Revenue Analysis',
    benefits: 'Benefits',
    selectDates: 'Select Dates',
    energyBalance: 'Energy Balance',
    selfConsumption: 'Self-Consumption',
    exportLabel: 'Export',
    selfSufficiency: 'Self-Sufficiency',
    buyFromGrid: 'Buy from Grid',
    supply: 'Supply (kW)',
    usage: 'Usage',
    loads: 'Loads',
    network: 'Network',
    solarGen: 'Solar',
    generation: 'Generation',
    imported: 'Imported',
    pvProduced: 'PV Produced',
    discharged: 'Discharged',
    exported: 'Exported',
    consumed: 'Consumed',
    charged: 'Charged',
    selectPeriod: 'Select Period',
    fromDate: 'From Date',
    toDate: 'To Date',

    productionPlanning: 'Production Planning',
    selectDate: 'Date (calendar for history)',
    selectCompanyForData: 'Select a company to view data.',
    selectDateAndSearch: 'Select a date (or Yesterday) and click Search.',
    clickSearchHint: 'Click Search to fetch data for {date}.',
    loadingData: 'Loading data...',
    noEnergyMeters: 'No energy meters for this company.',
    weatherHint: 'Weather data (GHI, temp, wind) will appear when you install weather station.',
    hour: 'Hour',
    emProduction: 'EM Production (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Difference (EM−DL)',
    radiationGhi: 'Radiation (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. module °C',
    windSpeed: 'Wind (m/s)',
    weatherOnlyHint: 'Weather only (Open-Meteo). Production will appear when you install energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Diff = EM − DL (positive = meter more than datalogger, negative = datalogger more).',
    data: 'Date',
    productionAndWeatherHourly: 'Production and weather by hour (05:00–20:00)',

    companiesTitle: 'Companies',
    companiesSubtitle: 'Manage companies and data',
    setDashboardPhoto: 'Set dashboard photo for all',
    setting: 'Setting...',
    addCompany: '+ Add Company',
    totalCompanies: 'Total Companies',
    noCompaniesRegistered: 'No companies registered',
    addFirstCompany: 'Add the first company to get started',
    logo: 'Logo',
    companyName: 'Company name',
    address: 'Address',
    phone: 'Phone',
    website: 'Website',
    uniqueNr: 'Unique Nr',
    vatNr: 'VAT Nr',
    hold3sForLogo: 'Hold 3 seconds to upload logo (PNG)',
    editCompany: 'Edit Company',
    addNewCompany: 'Add New Company',
    dashboardPhoto: 'Dashboard photo (optional)',
    dashboardPhotoHint: 'Each company has its own photo on the first page (dashboard)...',
    selectDashboardPhoto: 'Select dashboard photo',
    companyNameRequired: 'Company name *',
    selectPhoto: 'Select a PNG image...',
    selectImage: 'Select Image',
    pngOnly: 'PNG files only (.png).',
    confirmDeleteCompany: 'Are you sure you want to delete this company?',
    confirmSeedDashboardPhotos: 'Set dashboard photo (company_comp-frigofood_aa3a78e3) for all companies? You can change it later from the Edit Company modal.',
    logoUploaded: 'Logo uploaded successfully!',
    uploadError: 'Upload error',
    imagesOnly: 'Only images allowed: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Dashboard photo uploaded successfully!',
    companySaveError: 'Error saving company.',

    usersTitle: 'Users',
    addUser: '+ Add User',
    ensureBackendRunning: 'Make sure the backend (FastAPI) is running on port 8000.',
    tryAgain: 'Try again',
    closeMessage: 'Close',
    closeMessageAria: 'Close message',
    name: 'Name',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Company',
    editUser: 'Edit User',
    addNewUser: 'Add New User',
    fullName: 'Full Name',
    fullNameAlt: 'Full Name',
    passwordOptional: 'Password (optional)',
    role: 'Role',
    navigation: 'Navigation',
    selectCompanyUsers: 'Select Company',
    allowedNavigation: 'Allowed Navigation',
    none: 'None',
    companiesCount: 'companies',
    pages: 'pages',
    allOption: 'All',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    saveError: 'Error saving.',
    deleteUserError: 'Error deleting.',

    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    inverterNotFound: 'Inverter not found',
    inverterDetails: 'Inverter Details',
    statusAndEnergy: 'Status & Energy',
    power: 'Power',
    pvVoltage: 'PV Voltage',
    pvCurrent: 'PV Current',
    gridAndPhase: 'Grid & Phase',
    system: 'System',
    pvPower: 'PV Power',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    monthlyPvYield: 'Monthly PV Yield',
    energyAnalysis: 'Energy Analysis',
    details: 'Details',
    realTime: 'Real Time',
    alarms: 'Alarms',
    realtimeCurve: 'Real-time Curve',
    deviceStatus: 'Device status',
    energyYieldCurrentDay: 'Energy yield of current day',
    totalEnergyYield: 'Total energy yield',
    reducedCo2Emission: 'Reduced CO2 emission',
    dcPower: 'DC power',
    activePower: 'Active power',
    reactivePower: 'Reactive power',
    powerFactor: 'Power factor',
    gridAbBcCaVoltage: 'Grid AB/BC/CA voltage',
    gridAbcPhaseCurrent: 'Grid A/B/C phase current',
    todayPeakActivePower: "Today's peak active power",
    gridFrequency: 'Grid frequency',
    locking: 'Locking',
    cabinetTemperature: 'Cabinet temperature',
    startupTime: 'Startup time',
    shutdownTime: 'Shutdown time',
    collectDspData: 'Collect DSP data',
    activePowerAdjustment: 'Active power adjustment',
    reactivePowerAdjustment: 'Reactive power adjustment',
    pv18Voltage: 'PV1-8 voltage',
    pv916Voltage: 'PV9-16 voltage',
    pv1724Voltage: 'PV17-24 voltage',
    pv2528Voltage: 'PV25-28 voltage',
    pv18Current: 'PV1-8 current',
    pv916Current: 'PV9-16 current',
    pv1724Current: 'PV17-24 current',
    pv2528Current: 'PV25-28 current',
    allDevices: 'All Devices',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'No alarms.',

    energyMeterNotFound: 'Energy Meter not found',
    alarmHistoryLabel: 'Alarm History',
    activeAlarmsLabel: 'Active Alarms',
    noActiveAlarms: 'No active alarms.',
    noAlarms: 'No alarms.',
    activePowerReal: 'Active Power (Real Power)',
    todayEnergy: 'Today Energy',
    monthlyEnergy: 'Monthly Energy (1–31)',
    totalEnergyLabel: 'Total Energy',
    meterDetails: 'Meter Details',
    energyAnalysisLabel: 'Energy Analysis',
    inOut: 'IN-OUT',
    photoUpload: 'Upload Photo',
    photoUploadFor: 'Upload Photo for',
    selectPhoto: 'Select Photo',
    exportLabel: 'Export',
    totalLabel: 'Total',
    emSectionPower: 'Power',
    emSectionEnergy: 'Energy',
    emSectionVoltage: 'Voltage',
    emSectionCurrent: 'Current',
    emSectionFrequency: 'Frequency',
    emSectionDemand: 'Demand (Peak)',
    emSectionAdvanced: 'Advanced',
    digitalIO: 'Digital I/O',
    inputs: 'Inputs',
    outputs: 'Outputs (hold >5s to write)',
    figureScheme: 'Figure / Scheme',
    verifyPayload: 'Verify payload (raw from API)',
    writeDO: 'Write DO1/DO2',
    confirmStopStart: 'Are you sure? Turn off or on?',
    send: 'Send',

    detailedParameters: 'Detailed Parameters',
    pvInfo: 'PV Information',
    voltage: 'Voltage(V)',
    currentLabel: 'Current(A)',
    powerLabel: 'Power(kW)',
    frequency: 'Frequency(H...',
    gridInfo: 'Grid Information',
    gridStatus: 'Grid Status',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',

    dlInputPowerDc: 'Input Power DC',
    dlGridPhaseCurrents: 'Grid Phase Currents',
    dlLockStatus: 'Lock Status',
    dlReactiveAdjustmentLimits: 'Reactive Adjustment Limits',
    dlActiveAdjustmentLimits: 'Active Adjustment Limits',
    dlPvReactiveLimits: 'PV Reactive Limits',
    dlEssReactiveLimits: 'ESS Reactive Limits',
    dlPvActiveLimit: 'PV Active Limit',
    dlEssPeaks: 'ESS Peaks',
    dlApiOverrideStatuses: 'API Override Statuses',
    dlRemoteScheduling: 'Remote Scheduling',
    dlKpi: 'KPI',
    dlInputPowerKw: 'Input Power (kW)',
    dlDcCurrentA: 'DC Current (A)',
    dlGridAPhaseCurrent: 'Grid A Phase Current (A)',
    dlGridBPhaseCurrent: 'Grid B Phase Current (A)',
    dlGridCPhaseCurrent: 'Grid C Phase Current (A)',
    dlLockStatusLabel: 'Lock Status',
    dlReducedCo2Kg: 'Reduced CO₂ (kg)',
    dlMaxReactiveAdj: 'Max. reactive adjustment (kVar)',
    dlMinReactiveAdj: 'Min. reactive adjustment (kVar)',
    dlMaxActiveAdj: 'Max. active adjustment (kW)',
    dlMinActiveAdj: 'Min. active adjustment (kW)',
    dlPvReactiveMax: 'Highest reactive PV (kVar)',
    dlPvReactiveMin: 'Lowest reactive PV (kVar)',
    dlEssReactiveMax: 'Highest reactive ESS (kVar)',
    dlEssReactiveMin: 'Lowest reactive ESS (kVar)',
    dlPvActiveMax: 'Highest active PV (kW)',
    dlEssDischargeMax: 'ESS Max Discharge (kW)',
    dlEssChargeMax: 'ESS Max Charge (kW)',
    dlApiActiveOverride: 'API active override (lower priority)',
    dlApiReactiveOverride: 'API reactive override (lower priority)',
    dlRemoteSchedP: 'Remote scheduling (P)',
    dlRemoteSchedQ: 'Remote scheduling (Q)',

    // Dashboard S475, S475Detail, Check-in, Companies, MeSettings, Notification, ChangePassword
    selectCompanyPlaceholder: 'Select company',
    selectLocationPlaceholder: 'Select location',
    connectionError: 'Connection error',
    writeError: 'Write error',
    lastUpdated: 'Last updated',
    clickToChange: 'Click to change',
    selectDevicePlaceholder: 'Select a device',
    backToDevices: 'Back to Devices',
    deviceNotFound: 'Device not found.',
    configForDashboard: 'Configuration for Dashboard',
    selected: 'Selected',
    clickToSelect: 'Click to select',
    errorSaving: 'Error saving',
    selectLocationHint: 'Select the location where you are (e.g. Boge, Mitrovicë).',
    loadingLocations: 'Loading locations…',
    noLocations: 'No locations available.',
    openCameraAndPhoto: 'Open camera and take photo',
    capturePhoto: 'Capture photo',
    locationLabel: 'Location',
    retake: 'Retake',
    confirmCheckin: 'Confirm check-in',
    lastCheckins5: 'Last check-ins (5)',
    lastCheckins10: 'Last 10 check-ins',
    noCheckinsYet: 'No check-ins yet. Select location and take a photo to register.',
    dateTimeColumn: 'Date / Time',
    photoColumn: 'Photo',
    viewPhotoLarge: 'View full size photo',
    checkinFailed: 'Check-in failed',
    checkinSuccessToast: 'Check-in registered.',
    checkoutSuccess: 'Checkout registered.',
    checkoutCommentRequired: 'For checkout, enter a comment (what was fixed / state) before the photo.',
    checkoutCommentPrefilledHint: 'Comment was filled from the visit (extras modal). You can edit it before the camera.',
    checkoutCommentReminder: 'Checkout comment',
    checkoutButton: 'Checkout (photo + comment)',
    checkoutStepTitle: 'Step 1: checkout comment',
    continueToCamera: 'Continue to camera',
    addFuelRowButton: 'Add fuel / parts',
    addFuelPlusColumn: '+',
    addFuelAria: 'Add fuel or product for this visit',
    fuelModalTitle: 'Extras for last visit',
    saveFuelButton: 'Save',
    litersFuelPlaceholder: 'Fuel liters (number)',
    partsCountPlaceholder: 'Parts / fuses (integer)',
    productFieldLabel: 'Product',
    fuelModalCommentOptional: 'Comment (optional) for this visit',
    commentRepairPlaceholder: 'Comment: what was fixed',
    fuelSavedToast: 'Saved.',
    fuelInvalidLiters: 'Fuel liters: enter a valid number (or leave empty).',
    fuelInvalidParts: 'Product: enter a valid whole number (or leave empty).',
    eventKindCheckin: 'Check-in',
    eventKindCheckout: 'Checkout',
    cameraError: 'Camera could not be opened',
    confirmDeleteTitle: 'Confirm delete',
    selectLogo: 'Select logo',
    companyNamePlaceholder: 'Company name',
    languageLabel: 'Language',
    darkLightMode: 'Dark / Light mode',
    darkMode: 'Dark',
    lightMode: 'Light',
    langShqip: 'Shqip',
    langEnglish: 'English',
    currentPasswordLabel: 'Current password',
    newPasswordLabel: 'New password',
    confirmNewPasswordLabel: 'Confirm new password',
    currentPasswordRequired: 'Enter current password.',
    newPasswordMinLength: 'New password must be at least 4 characters.',
    passwordsDoNotMatch: 'New password and confirmation do not match.',
    passwordChangedSuccess: 'Password changed successfully.',
    passwordChangeError: 'Password could not be changed.',
    notificationsTitle: 'Notifications',
    selectDevice: 'Select device',
    saveNotifications: 'Save',
    testEmail: 'Send test email',
    notificationSelectDeviceHint: 'Select the device and enable Push and/or Email for each notification type.',
    deviceLabel: 'Device',
    testEmailFailed: 'Test email failed.',
    notificationFooter: 'Notifications are sent to your account email and as push on the device where you enabled notifications.',
    notificationsAlarmsTitle: 'Alarms',
    notificationsSuperConfigHint: 'For Push/Email notification preferences, open System settings (device selection is there).',
    noAlarmsInList: 'No alarms for this filter.',
    alarmActiveBadge: 'Active',
    reportsSuperAdminOnly: 'Check-in and fuel reports are for super admin only.',
    reportSessionIn: 'Check-in',
    reportSessionOut: 'Check-out',
    reportWorkHoursColumn: 'Work hours',
    reportTotalWorkHours: 'Total work hours',
    deviceNotifSectionTitle: 'Push / email notifications (this device)',
    deviceNotifSectionDesc: 'Enable channels for this device’s alarms. Save after changes.',
    deviceNotifTestEmail: 'Send test email',
    deviceNotifSaved: 'Notification preferences saved.',
    deviceNotifTestOk: 'Test email sent.',
    deviceNotifTestFail: 'Test email failed.',
    push: 'Push',
    emailNotif: 'Email',
    valuesNotReading: 'Values could not be read',
    doSetTo: 'set to',
    lastLabel: 'Last',
    voltDc: 'Volt DC',
    tempChannel: 'Temperature',
    humidityChannel: 'Humidity',
    totalKwChannel: 'Total kW',
    frequencyChannel: 'Frequency',
  },
};
